export const initialState = {
  actionProcessing: false,
  activeUsersStatistic: {
    isLoading: false,
    requestKey: '',
    data: null,
    timeseriesKey: '',
    timeseries: null,
  },
  statisticProvider: {
    providers: [],
    detail: {
      betCount: 0,
      betAmount: 0,
      winAmount: 0,
      incomeAmount: 0,
      commissionBalance: 0,
      lastCalculateTime: '',
      margin: 0,
      activeUsers: 0,
      rtp: 0,
      /* isOutdated: false, */
    },
    diff: {
      betCount: '0',
      betCountPercent: 0,
      betAmount: '0',
      betAmountPercent: 0,
      winAmount: '0',
      winAmountPercent: 0,
      incomeAmount: '0',
      incomeAmountPercent: 0,
      commissionBalance: '0',
      commissionBalancePercent: 0,
      margin: '0',
      marginPercent: 0,
      activeUsers: '0',
      activeUsersPercent: 0,
      rtp: '0',
      rtpPercent: 0,
    },
    providersDiff: {},
  },
  reportTimeseries: {
    current: [],
    previous: [],
  },
  providerTimeseries: {},
  providerRanks: {
    topByNetwin: [],
    biggestWins: [],
  },
  savedFilters: [],
  paymentHistory: {
    transfers: [],
    details: {
      totalCount: 0,
      totalDeposit: 0,
      totalWithdraw: 0,
      deltaBalance: 0,
      lastCalculateTime: '',
    },
  },
  paymentHistoryTotals: {
    totalDeposit: 0,
    totalWithdraw: 0,
    deltaBalance: 0,
    balance: 0,
  },
  statisticPlayer: {
    userStatistic: [],
    details: {
      totalCount: 0,
    },
  },
  slotsHistory: {
    data: [],
    totalCount: 0,
    details: {
      totalBetCount: 0,
      totalBet: 0,
      totalWon: 0,
      totalIncome: 0,
    },
  },
  betsHistory: {
    data: [],
    count: 0,
  },
  betInfo: {
    provider: '',
    date: '',
    gameName: '',
    balanceBefore: '',
    balanceAfter: '',
    userId: '',
    username: '',
    operation: '',
    amount: '',
    refId: '',
  },
  playerDeposits: {
    data: [],
    count: 0,
    cbu: '',

    // pollingFilters: {},
    // differentCount: 0,
  },
  requestHistory: {
    data: [],
    count: 0,
  },
};
